import { render } from "./CommonBottom.vue?vue&type=template&id=56803d5c"
import script from "./CommonBottom.vue?vue&type=script&lang=js"
export * from "./CommonBottom.vue?vue&type=script&lang=js"

import "./CommonBottom.vue?vue&type=style&index=0&id=56803d5c&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__